import app from 'app';
import ready from 'utils/ready';
import filterItem from 'components/filter-item';
import filterMobile from 'components/filter-mobile';
import collection from './collection/main';

app.add({
  collection,
  'filter-item': filterItem,
  'filter-mobile': filterMobile,
});

ready(app.mount);
